import { render, staticRenderFns } from "./MQSeriesConfigurationDetails.vue?vue&type=template&id=5703d748&"
import script from "./MQSeriesConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./MQSeriesConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports